const NumberFormatOptions = {
  localeMatcher: "best fit",
  style: "currency",
  currency: "RUB",
  currencyDisplay: "symbol",
  useGrouping: true,
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
};

export { NumberFormatOptions };
